import { createRouter, createWebHistory, NavigationFailure, RouteLocationNormalized, RouteMeta, RouteRecordRaw } from 'vue-router';
import SplashPage from '../pages/SplashPage/SplashPage.vue';
import IntroductionPage from '../pages/IntroductionPage/IntroductionPage.vue';
import ThemesPage from '../pages/ThemesPage/ThemesPage.vue';
import { Component } from 'vue';
import i18n from '@/i18n';
import BusEvent from '../../../shared/js/BusEvent';
import { EventStore, MenuStore } from '@/store';

const prefix: string = '';
// @ts-ignore
if (typeof webpackHotUpdate !== 'undefined') {
  console.log('In Dev Mode');
  // fake the 3D ready event
  setTimeout(() => {
    document.dispatchEvent(new BusEvent(BusEvent.EVENTS.READY));
  }, 2000);
}

export interface IVimyRoutePath {
  path: string;
  name: string;
}

export interface IVimyRoute {
  paths: IVimyRoutePath[];
  component: Component,
  meta?: RouteMeta;
}

const routes: IVimyRoute[] = [
  {
    paths: [
      {
        path: `/`,
        name: 'Home'
      }
    ],
    component: SplashPage,
    meta: {
      transition: 'fade'
    }
  },
  {
    paths: [
      {
        path: `/introduction`,
        name: 'IntroductionPage'
      }
    ],
    component: IntroductionPage,
    meta: {
      transition: 'fade'
    }
  },
  {
    paths: [
      {
        path: `/themes`,
        name: 'ThemesPage'
      }
    ],
    component: ThemesPage,
    meta: {
      transition: 'fade'
    }
  }
];

const routerRoutes: RouteRecordRaw[] = [];
for (const route of routes) {
  for (const path of route.paths) {
    routerRoutes.push(
      {
        path: `/:lang?${prefix}${path.path}`,
        name: path.name,
        component: route.component,
        meta: route.meta
      }
    );
  }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routerRoutes,

  scrollBehavior(to, from, savedPosition) {
    if (!to.hash) return;

    return {
      el: to.hash,
      behavior: 'smooth'
    }
  }
});

let ready = false;
let skipIntro = false;
EventStore.$watch(t => t.ready, (value, _) => {
  ready = true;
});

function checkReady() {
  if (!ready) {
    setTimeout(checkReady, 100);
    return;
  }

  if (skipIntro)
    bypassIntro();
}

function bypassIntro() {
  EventStore.triggerIntroductionProgress({
    progression: true,
    previousStep: 0,
    step: 1,
    isContinue: false,
    totalSteps: 1,
    progress: 100.0
  });
  EventStore.triggerIntroductionCompleted();
}

function resetIntro() {
  EventStore.triggerIntroductionProgress({
    progression: true,
    previousStep: 0,
    step: 0,
    isContinue: false,
    totalSteps: 1,
    progress: 0.0
  });
}

router.beforeEach(
  async (to, from, next) => {
    MenuStore.close();

    // we loaded page that is not introduction, call the 3D reveal event
    if (from.name == undefined && to.name != 'IntroductionPage' && to.name !== 'Home') {
      skipIntro = true;
      if (ready)
        bypassIntro();
      else
        checkReady();
    }
    else if (to.name === 'Home') {
      resetIntro();
    }

    if (typeof to.params.lang !== 'string' || to.params.lang.length != 2) {
      next();
      return;
    }

    i18n.global.locale.value = to.params.lang;
    document.dispatchEvent( new BusEvent(BusEvent.EVENTS.LANG, {lang: to.params.lang}))

    next();
  }
);

router.afterEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, failure?: NavigationFailure | void) => {
    window.history.replaceState(history.state, '', '/');
  }
);

export default router;
